@let rootOutcome = rootOutcomeSg();

<div class="atn-summit-allocation-graph">
  @if (rootOutcome) {
    <atn-summit-allocation-graph-root-outcome
      [outcome]="rootOutcome"
      (linkClicked)="onOutcomeLinkClicked($event)"
    />
  }

  <div
    class="atn-summit-allocation-graph__svg-container"
    #container
  ></div>
</div>

@let hoveredOutcome = hoveredOutcomeSg();
@let hoveredUnit = hoveredUnitSg();

@if (hoveredOutcome) {
  <atn-summit-allocation-graph-outcome-overlay
    class="atn-summit-allocation-graph__overlay"
    [origin]="hoveredOutcome.position"
    [outcome]="hoveredOutcome.data"
  />
}
@if (hoveredUnit) {
  <atn-summit-allocation-graph-unit-overlay
    class="atn-summit-allocation-graph__overlay"
    [origin]="hoveredUnit.position"
    [unit]="hoveredUnit.data"
  />
}
